export default "__VITE_ASSET__ae45a257__"